module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-750-Classes-Active-a12cee64af67c94fec4d8283038af758.png";